import { useEffect } from "react";

function AlterarSenha({history}) {

    useEffect(() => {
        window.open('https://account.activedirectory.windowsazure.com/ChangePassword.aspx', '_blank');
        history.push('/dashboard');
    }, []);

    return null;
}

export default AlterarSenha;
